import { ReactElement } from 'react';
import { Container } from '@mui/material';

import { mapDataToUndefinedIfSkip } from 'modules/api/utils';
import { useConnection } from 'modules/auth/hooks/useConnection';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { useGetIsOwnerPoolQuery } from 'modules/ownerPanel/actions/isPoolOwner';
import { AddSelfStakeDialog } from 'modules/ownerPanel/components/AddSelfstakeDialog/AddSelfStakeDialog';
import { EditPoolDialog } from 'modules/ownerPanel/components/EditPoolDialog';
import { ReturnStats } from 'modules/ownerPanel/components/ReturnStats';
import { OwnerPanelRoutesConfig } from 'modules/ownerPanel/Routes';
import { Stats } from 'modules/pool/components/Stats';

import { Details } from '../../components/Details';
import { useStyles } from './useStyles';

export function Pool(): ReactElement {
  const { classes } = useStyles();

  const { isConnected, connectionKey } = useConnection();
  const { isOpened } = useDialog(KnownDialogs.addSelfstake);
  const { poolAddress } = OwnerPanelRoutesConfig.pool.useParams();

  const { data: isOwnerPool } = useGetIsOwnerPoolQuery(
    { connectionKey, poolAddress },
    {
      skip: !isConnected || !poolAddress,
      selectFromResult: mapDataToUndefinedIfSkip,
    },
  );

  console.log('isOwnerPool', isOwnerPool);

  // if (!poolAddress || (typeof isOwnerPool === 'boolean' && !isOwnerPool)) {
  //   return <Navigate to={DashboardRoutesConfig.dashboard.generatePath()} />;
  // }

  return (
    <Container className={classes.root}>
      <div className={classes.top}>
        <Details className={classes.details} poolAddress={poolAddress} />

        <Stats showDialogButtons poolAddress={poolAddress} />
      </div>

      <ReturnStats poolAddress={poolAddress} />

      <EditPoolDialog />

      {isOpened && <AddSelfStakeDialog />}
    </Container>
  );
}
